<span [innerHTML]="'NOTIFICATION_TEMPLATES.NORM'|translate:notification"></span>
